var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("article", [
    _c("canvas", { ref: "canvas", staticClass: "barChart" })
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }